// @flow
import { createAction } from 'redux-actions';
import * as constants from './constants';

export const checkServiceOutageStatus = createAction(
    constants.CHECK_SERVICE_OUTAGE_STATUS,
    (serviceUrlBase, userLocale) => ({
        serviceUrlBase,
        userLocale
    })
);
export const receiveServiceOutage = createAction(constants.RECEIVE_SERVICE_OUTAGE_STATUS);
export const showAlertNotification = createAction(constants.SHOW_ALERT_NOTIFICATION);
export const hideAlertNotification = createAction(constants.HIDE_ALERT_NOTIFICATION);



// WEBPACK FOOTER //
// ./src/core/state/service-outage/actions.js